import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06adbb4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "container"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Calls Review", -1))
const _hoisted_4 = { class: "row data center horizontal-center" }
const _hoisted_5 = { class: "text-center total-calls" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Calls Received", -1))
const _hoisted_7 = { class: "row data center horizontal-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "IVR Payments", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" View IVR Transactions ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Agent Payments", -1))
const _hoisted_11 = { class: "row data center horizontal-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Rentals", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Customer Notes", -1))
const _hoisted_14 = { class: "row data center horizontal-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Overdue Calls", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  class: "text-center",
  style: {"margin":"35px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Total Calls", -1))
const _hoisted_19 = { class: "border" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"left","padding":"10px 0 0"} }, " ** All times are in Mountain Time (America/Denver). ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Time"),
  /*#__PURE__*/_createElementVNode("th", null, "Disposition"),
  /*#__PURE__*/_createElementVNode("th", null, "Facility")
], -1))
const _hoisted_22 = { style: {"min-width":"23vw"} }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Misc.")
const _hoisted_24 = { style: {"min-width":"23vw"} }

import { ref, computed } from "vue";
import { useStore } from "@/store";
import api from "@virgodev/bazaar/functions/api";
import BaseSpinner from "@/components/BaseSpinner.vue";
import Filter from "@/components/Filter.vue";
import BaseLineChart from "@/components/BaseLineChart.vue";
import { parseYMDLocal, monthLabel } from "@/utils/timeSeries";
import "@vueform/multiselect/themes/default.scss";

type NumLike = number | string | null | undefined;

type CallsReportRow = {
  start_date: string;
  total_calls: number;
};

type CallItem = {
  id: string | number;
  date: string;
  disposition?: string | null;
};

type CallsList = {
  facility_name: string;
  call_information: CallItem[];
};

type CallsKpiReportRow = {
  start_date: string;
  ivr_payments: number;
  agent_payments: number;
  rentals: number;
  customer_notes: number;
  tenant_overdue_calls: number;
};

type Series = { labels: string[]; data: number[] };

type ClientLite = {
  name: string;
  facilities: Array<{ facility_name: string }>;
};

type Option = { label: string; value: string | null; disabled: boolean };


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formSubmitting = ref(false);
const errors = ref("");
const showCalls = ref(false);
const status = ref("loading");
const isLoading = computed(
  () => status.value === "loading" || formSubmitting.value
);

const store = useStore();
const client = ref();
const facilityOptions = ref<Option[]>([]);
const formFields = computed(() => store.clientPortalFormFields);
const dateOptions = ref([
  { text: "Current month", value: "current_month" },
  { text: "Last month", value: "last_month" },
  { text: "All year", value: "all_year" },
  { text: "Custom Dates", value: "custom" },
]);

// server payload
const facilityData = ref<{
  calls_answered: number | string;
  calls: CallsList[];
  calls_report?: CallsReportRow[];
  calls_kpis_report?: CallsKpiReportRow[];
  ivr_payments: number | string;
  agent_payments: number | string;
  rentals: number | string;
  customer_notes: number | string;
  tenant_overdue_calls: number | string;
}>({
  calls_answered: "-",
  calls: [],
  calls_report: [],
  calls_kpis_report: [],
  ivr_payments: "-",
  agent_payments: "-",
  rentals: "-",
  customer_notes: "-",
  tenant_overdue_calls: "-",
});

const asInt = (n: number | string) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
    Number(n) || 0
  );

const selectedDate = computed(
  () => (store.clientPortalFormFields || {}).selected_date
);

// ---- Time-zone-aware formatters ----
const DEFAULT_TIME_ZONE = "America/Denver";

function normalizeIsoToUTC(iso: string) {
  const s = iso.trim().replace(" ", "T");
  if (/([Zz]|[+-]\d{2}:?\d{2})$/.test(s)) return s;
  return `${s}Z`;
}

function parseIsoDate(iso: string) {
  if (!iso) return null;
  const normalized = normalizeIsoToUTC(iso);
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

function resolveTimeZone(tz?: string | null) {
  const candidate = (tz || "").trim();
  if (!candidate) return DEFAULT_TIME_ZONE;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: candidate }).format(
      new Date()
    );
    return candidate;
  } catch {
    return DEFAULT_TIME_ZONE;
  }
}

function getPart(parts: Intl.DateTimeFormatPart[], type: string) {
  return parts.find((p) => p.type === type)?.value ?? "";
}

function formatDateInTZ(iso: string, tz?: string | null) {
  const d = parseIsoDate(iso);
  if (!d) return "";
  const timeZone = resolveTimeZone(tz);
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(d);
  const month = getPart(parts, "month");
  const day = getPart(parts, "day");
  const year = getPart(parts, "year");
  return `${month}-${day}-${year}`;
}

function formatTimeInTZ(iso: string, tz?: string | null, showTZ = true) {
  const d = parseIsoDate(iso);
  if (!d) return "";
  const timeZone = resolveTimeZone(tz);
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    ...(showTZ ? { timeZoneName: "short" } : {}),
  }).formatToParts(d);
  const hour = getPart(parts, "hour");
  const minute = getPart(parts, "minute");
  const second = getPart(parts, "second");
  const dayPeriod = getPart(parts, "dayPeriod");
  const tzName = getPart(parts, "timeZoneName");
  const base = `${hour}:${minute}:${second} ${dayPeriod}`;
  return showTZ && tzName ? `${base} ${tzName}` : base;
}

// generic series builder (just like on TPP)
function buildSeries<T extends { start_date: string }>(
  rows: T[],
  key: keyof T
): Series {
  const sorted = (rows || []).slice().sort((a, b) => {
    const da = parseYMDLocal(a.start_date)?.getTime() ?? 0;
    const db = parseYMDLocal(b.start_date)?.getTime() ?? 0;
    return da - db;
  });

  const needsTrend =
    selectedDate.value === "current_month" ||
    selectedDate.value === "last_month";
  const windowed = needsTrend ? sorted.slice(-4) : sorted;

  const labels = windowed.map((r) => {
    const d = parseYMDLocal(r.start_date);
    return d ? monthLabel(d) : "Unknown";
  });

  const data = windowed.map((r) =>
    Number((r as Record<string, unknown>)[String(key)] ?? 0)
  );

  return { labels, data };
}

// expose all the call series your UI will chart
const series = computed(() => {
  const callsReport = facilityData.value.calls_report || [];
  const kpiReport = facilityData.value.calls_kpis_report || [];

  return {
    totalCalls: buildSeries(callsReport, "total_calls"),
    ivr: buildSeries(kpiReport, "ivr_payments"),
    agent: buildSeries(kpiReport, "agent_payments"),
    rentals: buildSeries(kpiReport, "rentals"),
    notes: buildSeries(kpiReport, "customer_notes"),
    overdue: buildSeries(kpiReport, "tenant_overdue_calls"),
  };
});

function toYMD(d: string | Date | null | undefined) {
  return d instanceof Date ? d.toISOString().slice(0, 10) : d;
}

async function getUserInfo() {
  status.value = "loading";
  errors.value = "";
  const response = await api({ url: `client/` });
  if (response.status === 200) {
    const body = response.body as ClientLite[] | undefined;
    client.value = body?.[0] ?? null;

    facilityOptions.value = [
      { label: "All Facilities", value: null, disabled: true },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(client.value?.facilities ?? []).map((f: { facility_name: any }) => ({
        label: f.facility_name,
        value: f.facility_name,
        disabled: false,
      })),
    ];
    await submitForm();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your connection and try again.";
  }
  status.value = "loaded";
}

async function submitForm(formData?: typeof formFields.value) {
  errors.value = "";
  formSubmitting.value = true;
  if (formData) store.setClientPortalFormFields(formData);
  const raw = formData ?? store.clientPortalFormFields;

  const payload = {
    ...raw,
    start_date: toYMD(raw.start_date),
    end_date: toYMD(raw.end_date),
  };

  if (!payload.selected_facilities?.length) {
    payload.selected_facilities =
      client.value?.facilities.map(
        (f: { facility_name: string }) => f.facility_name
      ) || [];
  }

  const res = await api({
    url: `client/facility_data/`,
    method: "POST",
    json: payload,
  });
  if (res.status === 200) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const b = (res.body || {}) as Partial<any> & {
      calls_report?: Array<
        Partial<CallsReportRow> & { total_calls?: NumLike; start_date?: string }
      >;
      calls_kpis_report?: Array<
        Partial<CallsKpiReportRow> & Record<string, NumLike>
      >;
      calls?: CallsList[];
    };

    // coerce numeric keys we chart
    const calls_report: CallsReportRow[] = normArray(b.calls_report).map(
      (r) => ({
        start_date: r.start_date ?? "",
        total_calls: Number(r.total_calls ?? 0),
      })
    );

    const calls_kpis_report: CallsKpiReportRow[] = normArray(
      b.calls_kpis_report
    ).map((r) => ({
      start_date: r.start_date ?? "",
      ivr_payments: Number(r.ivr_payments ?? 0),
      agent_payments: Number(r.agent_payments ?? 0),
      rentals: Number(r.rentals ?? 0),
      customer_notes: Number(r.customer_notes ?? 0),
      tenant_overdue_calls: Number(r.tenant_overdue_calls ?? 0),
    }));

    facilityData.value = {
      ...facilityData.value,
      calls_answered: Number(b.calls_answered ?? 0),
      calls: b.calls || [],
      ivr_payments: Number(b.ivr_payments ?? 0),
      agent_payments: Number(b.agent_payments ?? 0),
      rentals: Number(b.rentals ?? 0),
      customer_notes: Number(b.customer_notes ?? 0),
      tenant_overdue_calls: Number(b.tenant_overdue_calls ?? 0),
      calls_report,
      calls_kpis_report,
    };
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your connection and try again.";
  }
  formSubmitting.value = false;
}

function normArray<T>(v: T | T[] | null | undefined): T[] {
  if (v == null) return [];
  return Array.isArray(v) ? v : [v];
}

function handleFilterSubmit(fd: typeof formFields.value) {
  submitForm(fd);
}

getUserInfo();

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (errors.value)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 0,
          variant: "danger",
          class: "js-form-error"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(errors.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 1,
          preset: "large"
        }))
      : _createCommentVNode("", true),
    (client.value && !_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, _toDisplayString(client.value.name), 1),
          (!showCalls.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(Filter, {
                  "facility-options": facilityOptions.value,
                  "date-options": dateOptions.value,
                  "initial-form-fields": _unref(formFields),
                  "form-submitting": formSubmitting.value,
                  onSubmit: handleFilterSubmit
                }, null, 8, ["facility-options", "date-options", "initial-form-fields", "form-submitting"]),
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("h3", null, _toDisplayString(asInt(facilityData.value.calls_answered)), 1),
                    _createVNode(BaseLineChart, {
                      labels: _unref(series).totalCalls.labels,
                      datasets: [{ label: 'Total Calls', data: _unref(series).totalCalls.data }],
                      "y-tick-format": asInt
                    }, null, 8, ["labels", "datasets"]),
                    (
              facilityData.value.calls_answered &&
              Number(facilityData.value.calls_answered) > 0
            )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-text",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (showCalls.value = !showCalls.value))
                        }, " View Calls "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("h3", null, _toDisplayString(asInt(facilityData.value.ivr_payments)), 1),
                    _createVNode(BaseLineChart, {
                      labels: _unref(series).ivr.labels,
                      datasets: [{ label: 'IVR Payments', data: _unref(series).ivr.data }],
                      "y-tick-format": asInt
                    }, null, 8, ["labels", "datasets"]),
                    (Number(facilityData.value.ivr_payments) > 0)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'IvrPayments' },
                          class: "btn btn-text"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_10,
                    _createElementVNode("h3", null, _toDisplayString(asInt(facilityData.value.agent_payments)), 1),
                    _createVNode(BaseLineChart, {
                      labels: _unref(series).agent.labels,
                      datasets: [{ label: 'Agent Payments', data: _unref(series).agent.data }],
                      "y-tick-format": asInt
                    }, null, 8, ["labels", "datasets"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _createElementVNode("h3", null, _toDisplayString(asInt(facilityData.value.rentals)), 1),
                    _createVNode(BaseLineChart, {
                      labels: _unref(series).rentals.labels,
                      datasets: [{ label: 'Rentals', data: _unref(series).rentals.data }],
                      "y-tick-format": asInt
                    }, null, 8, ["labels", "datasets"])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_13,
                    _createElementVNode("h3", null, _toDisplayString(asInt(facilityData.value.customer_notes)), 1),
                    _createVNode(BaseLineChart, {
                      labels: _unref(series).notes.labels,
                      datasets: [{ label: 'Customer Notes', data: _unref(series).notes.data }],
                      "y-tick-format": asInt
                    }, null, 8, ["labels", "datasets"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _createElementVNode("h3", null, _toDisplayString(asInt(facilityData.value.tenant_overdue_calls)), 1),
                    _createVNode(BaseLineChart, {
                      labels: _unref(series).overdue.labels,
                      datasets: [{ label: 'Overdue Calls', data: _unref(series).overdue.data }],
                      "y-tick-format": asInt
                    }, null, 8, ["labels", "datasets"])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "btn btn-text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showCalls.value = false))
                }, "Back"),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("h3", null, _toDisplayString(facilityData.value.calls_answered), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("table", null, [
                    _hoisted_21,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facilityData.value.calls, (call_list) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: call_list.facility_name + 'list'
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(call_list.call_information, (call) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: call.id + 'call'
                          }, [
                            _createElementVNode("td", null, _toDisplayString(formatDateInTZ(call.date)), 1),
                            _createElementVNode("td", null, _toDisplayString(formatTimeInTZ(call.date, undefined, false)), 1),
                            _createElementVNode("td", _hoisted_22, [
                              (call.disposition)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(call.disposition), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_23
                                  ], 64))
                            ]),
                            _createElementVNode("td", _hoisted_24, _toDisplayString(call_list.facility_name), 1)
                          ]))
                        }), 128))
                      ], 64))
                    }), 128))
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})